"use client";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Container from "@/components/common/container";
import IntegrationsMarketplace from "@/components/integrations/marketplace/IntegrationsMarketplace";

export default function MarketplacePage() {
  const { t } = useTranslation("partners");

  useEffect(() => {
    document.title = "Gail | " + t("marketplace");
  }, [t]);

  return (
    <Container>
      <IntegrationsMarketplace />
    </Container>
  );
}
